/**
 * Single sign-on handler class.
 */
import { HttpRequest } from './httpRequest';

export const signInUrl = 'dmsapi/api/Account/SkodaIdp';

export class SSOProvider extends HttpRequest {
	/**
	 * Sign user out.
	 * @return {Promise}
	 */
	signOut() {
		return this.post('/Account/Logout');
	}

	check(jwt: any = null) {
				return this.fetch('/Account'+(jwt==null?'':'?authorization='+jwt));
	}

}
